import { useRef } from 'react'
import { useRouter } from 'next/router'
import useTranslation from 'next-translate/useTranslation'
import { Divider, FlexboxGrid, Row } from 'rsuite'

import SupplierList from './SupplierList'
import { decycle } from '../../../services/useApiHelpers'
import { Supplier } from '../../../utils/types/Product'
import { NoSupplierResults } from '../../Graphics/EmptyStateGraphics'
import CatalogHeader from '../CatalogHeader'
import { getSupplierDeliveryDetails } from '../../../lib/service'
import CatalogLayout from '../../Layouts/CatalogLayout'
import CatalogItemCount from '../CatalogItemCount'
import { getCountryAndLocaleStrings } from '../../../utils/locales'
import ChatPanel from '../../ChatPanel'

import emptyStyles from '../../../styles/EmptyState.module.less'

interface SuppliersProps {
  suppliers: Supplier[]
  isLoading: boolean
  totalSuppliersAmount: number
}

const Suppliers: React.FC<SuppliersProps> = (props) => {
  const {
    suppliers,
    isLoading,
    totalSuppliersAmount,
  } = props

  const listRef = useRef<HTMLDivElement>(null)

  const { t } = useTranslation('products')
  const { locale: countryAndLocale } = useRouter()

  const { country } = getCountryAndLocaleStrings(countryAndLocale)

  decycle('supplier', suppliers)

  const displaySuppliers = suppliers
    .map((supplier) => ({
      ...supplier,
      product: [],
    }))
    .filter((supp) => (
      getSupplierDeliveryDetails(supp, country).isAvailable
    ))

  return (
    <Row className="margin-top-spacer margin-left-zero margin-right-zero">
      <div className="padding-left-spacer padding-right-spacer-double">
        <CatalogLayout
          catalogTab="suppliers"
        />
        <Divider className="margin-top-spacer-triple margin-bottom-spacer-double" />
        <CatalogHeader
          listRef={listRef}
          catalog="suppliers"
        />
        <CatalogItemCount
          totalItemsAmount={totalSuppliersAmount}
          catalogType="suppliers"
        />
        <FlexboxGrid>
          <SupplierList
            supplierMappedProducts={displaySuppliers}
            loadingSuppliers={isLoading}
          />
        </FlexboxGrid>
        {
            (!isLoading && !displaySuppliers.length) && (
              <div className={`${emptyStyles['empty-state']}`}>
                <NoSupplierResults />
                <h4 className={emptyStyles['empty-state-heading']}>{t('No matching suppliers')}</h4>
                <p>
                  {t('Modify your filters or ask an expert for more options')}
                </p>
                <ChatPanel
                  customTextContent={t('modals:Get help from our experts')}
                  chatPanelCtaText={t('modals:Chat with us')}
                  hideArrow
                  hideBorder
                />
              </div>
            )
          }
      </div>
    </Row>
  )
}

export default Suppliers
